import request from '@/utils/request'

// 查询证书管理列表
export function listCertificate(query) {
  return request({
    url: 'http://43.139.24.50:9090/business/certificate/list',
    method: 'get',
    params: query
  })
}

// 查询团体标准制定列表
export function listFormulate(query) {
  return request({
    url: 'http://43.139.24.50:9090/business/formulate/list',
    method: 'get',
    params: query
  })
}

// 查询团体标准发布列表
export function listPublish(query) {
  return request({
    url: 'http://43.139.24.50:9090/business/publish/list',
    method: 'get',
    params: query
  })
}

// 查询地方标准汇总列表
export function listStandard(query) {
  return request({
    url: 'http://43.139.24.50:9090/business/standard/list',
    method: 'get',
    params: query
  })
}

// 查询标准立项清单列表
export function listList(query) {
  return request({
    url: 'http://43.139.24.50:9090/business/list/list',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js